exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#template-management *[data-v-19bc9072]{-webkit-transform:all .5s;transform:all .5s}#template-management .head[data-v-19bc9072]  .el-input{width:200px}#template-management[data-v-19bc9072]  .el-card__body{height:100%}#template-management[data-v-19bc9072]  .el-table__row{cursor:pointer}", ""]);

// exports
